<template>
  <div class="index">
    <crumbs>
      <i class="icon-stack2"></i>
      <span class="text">{{multiLanguage.crumbs.authList}}</span>
    </crumbs>
    <div class="content">
      <div class="panel">
        <authMtable
          :thData="thData"
          :trData="trData"
          :multiLanguage="multiLanguage"
          :handle="handle"
          @deleteList="deleteList"
          @refresh="refresh"
          @addRefresh="tableAjax"
          >
        </authMtable>
      </div>
    </div>
  </div>
</template>

<script>
   import crumbs from "components/crumbs"
  import  {URL_USERDELETE,URL_FINDALLROLE,URL_DELETEROLE } from 'api/api.js'
  const MtablePar = {
    handle: {  //  操作中间几个按钮
      link: "authOption",  // 跳转路由
      idKey: "Role_ID",  // 跳转路由传id的key值
      delete: true,  // 设置有删除功能
      deleteUrl: URL_USERDELETE,  // 删除接口
      deleteKey: "Role_ID"  // 删除接口查询的key值
    }
  }

  export default {
    name: "authList",
    mixins: [
      require("common/mixin/base.js").base({registerLan:"authOption"}),
      require("common/mixin/base.js").base({multiLanguage:"tableModelAuthList"}),
      require("common/mixin/auth.js").AuthMtable(MtablePar)
    ],
   data () {
      return {
        trData: "", //  表格tr数据 
         handle: {  //  操作中间几个按钮
          link: "authOption",  // 跳转路由
          idKey: "Role_ID",  // 跳转路由传id的key值
          delete: true,  // 设置有删除功能
          deleteKey: "user_id"  // 删除接口查询的key值
        },
        }
    },
    mounted () {
      this.seekDropdown && (this.seekDropdown.seekStr = "")
    },
    computed: {
      thData() {  // 表格th数据
        return [this.multiLanguage.th.Role_ID,this.multiLanguage.th.Desc]
      }
    },
    methods: {
      tableAjax() {//获取数据
        this.$http(URL_FINDALLROLE).then((res) => {
          let data = res.data.data
          this.trData = data
        })
      },
       deleteList (list) { 
       if(list.length == 0){
         return;
       }
        this.$http.post(URL_DELETEROLE, {
          "role":list
        }).then(res => {
          if(res.data.code == 400){
            //TODO 翻译
             this.$message.error(this.registerLan.submitResult.role_error);
          }else{
             this.tableAjax()
          }
         
        })
      }
    },
     components: {
      crumbs
    }
  }
</script>

<style lang="scss" type="text/scss">

</style>



// WEBPACK FOOTER //
// authList.vue?732625a2